import styled from "styled-components";
import {StyledModal} from "../../common/shared/modal.styled";

export const InsuranceModalStyled = styled(StyledModal)`
    color: var(--bllink-gray);

    .modal-header {
        display: flex;
        padding: 15px 20px;
        border: none;
        justify-content: flex-end !important;

        button {
            flex: 0 0 16px;
            width: 16px;
            height: 16px;
            border: none;
            line-height: 0;
            background-color: transparent;
            cursor: pointer;
            padding: 0;
            color: var(--bllink-gray);
        }
    }

    .modal-body {
        padding-top: 0;

        h1 {
            margin-top: 0;
        }

        center {
            line-height: 29px;

            .advantages-block {
                text-decoration: underline;
                margin-bottom: 20px;
            }

            .buttons-block {
                margin-top: 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .decline {
                    font-weight: 700;
                    text-decoration: underline;
                    color: var(--bllink-purple);
                    cursor: pointer;
                }

                button {
                    font-size: 18px;
                }
            }   
        }
    }
`;
